import React from "react";
import { clsx } from "clsx";

import Headline from "~components/shared/headline/Headline";
import OptionalEyebrow from "~components/shared/optional-eyebrow/OptionalEyebrow";
import { HEADLINE_SIZE } from "~types/lineup";
import { getByline, getIsOpinionPageTheme, getCredits } from "~types/types";
import { getOpinionBybrowPrefix } from "~utils/opinionBybrow";

import { getOpinionAuthorsText } from "../brow/Brow";

import { type CardProps, CardSize } from "./Card";
import styles from "./Card.module.css";

export default function OpinionCard({
    size = CardSize.SMALL,
    item,
    className,
    storyIndex,
    linkType = "Story",
    relatedLinkType,
    relatedIndex,
    theme,
}: CardProps) {
    const { headline, url } = item;
    const byline = getByline(item);

    const isOpinionPageTheme = getIsOpinionPageTheme(theme);
    const storyCredits = getCredits(item) || [];

    const opinionAuthor = getOpinionAuthorsText(storyCredits);
    const opinionRole = getOpinionBybrowPrefix(storyCredits);

    const authorName = isOpinionPageTheme ? opinionAuthor : byline;
    const authorRole = isOpinionPageTheme ? opinionRole : "";

    return (
        <a
            href={url}
            data-component="opinion-card"
            data-link-type={linkType}
            data-link-index={storyIndex}
            data-link-related-type={relatedLinkType}
            data-link-related-index={relatedIndex}
            className={clsx(
                styles.card,
                styles.opinionCard,
                styles[size],
                className
            )}
        >
            <OptionalEyebrow
                authorName={authorName}
                authorRole={authorRole}
                presetLabel="opinionRelated"
                className={styles.optionalEyebrow}
            />
            <Headline
                text={headline}
                isPhoenix
                size={HEADLINE_SIZE.EXTRA_SMALL}
            />
        </a>
    );
}
